import { AbstractControl, FormArray, ValidatorFn } from '@angular/forms';

import { ValidationMessages } from '@/shared/_consts/validation-messages';

export class ValidationService {

  static getValidatorErrorMessage(
      validatorName: string,
      validatorValue?: any
  ): string {

    return ValidationMessages.getValidatorErrorMessage(
        validatorName,
        validatorValue
    );
  }

  static getPasswordValidationState(
      password: string | null | undefined
  ) {

    const value = password || '';

    return {
      hasMinLength: value.length >= 8,
      hasUppercase: /[A-Z]/.test(value),
      hasLowercase: /[a-z]/.test(value),
      hasNumber: /[0-9]/.test(value),
      hasSpecialChar: /[?!#$@%&*(){}]/.test(value)
    };
  }

  static passwordsMatch(
      password: string | null | undefined,
      confirmPassword: string | null | undefined
  ): boolean {

    return password === confirmPassword;
  }

  static passwordCnftValidator(control: AbstractControl): any {

    const confirmPassword = control.value || '';

    const passwordControl = control.root.get('password');

    if (!passwordControl) {
      return null;
    }

    const password = passwordControl.value || '';

    if (password !== confirmPassword) {

      return {
        invalidCnfPassword: true
      };
    }

    return null;
  }

  /**
   * RFC 2822 compliant regex.
   */
  static emailValidator(
      control: AbstractControl
  ): { [key: string]: boolean } | null {

    const value = control.value || '';

    const emailRegex =
        /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;

    if (value.match(emailRegex)) {
      return null;
    }

    return {
      invalidEmailAddress: true
    };
  }

  static passwordFormatValidator(control: AbstractControl): any {

    const value = control.value || '';

    if (
        value.match(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[?!@#$%&*(){}]).{8,100}$/
        )
    ) {

      return null;
    }

    return {
      invalidFormatPassword: true
    };
  }

  /**
   * Assert that the code is numeric
   */
  static validationEmailCode(control: AbstractControl): any {

    const value = control.value || '';

    if (value.match(/^[0-9]+$/)) {

      return null;
    }

    return {
      invalidValidationEmailCode: true
    };
  }

  static uniqueSpeakerNamesValidator: ValidatorFn =
      (control: AbstractControl) => {

        if (!(control instanceof FormArray)) {
          return null;
        }

        const names = control.controls
            .map(ctrl =>
                ctrl.get('name')?.value?.trim().toLowerCase()
            )
            .filter(n => !!n);

        const duplicates = names.filter(
            (n, i) => names.indexOf(n) !== i
        );

        return duplicates.length
            ? { duplicateNames: true }
            : null;
      };

  static phoneValidator(control: AbstractControl): any {

    const value = (control.value || '').trim();

    /**
     * Rules:
     * - Must start with +
     * - Can contain digits, spaces, (), -
     * - Total length 8 to 20
     *
     * Examples:
     * +33612345678
     * +33 6 12 34 56 78
     * +1 (555) 444-2222
     */

    if (
        value.match(
            /^\+[0-9\s()-]{7,19}$/
        )
    ) {

      return null;
    }

    return {
      invalidPhoneNumber: true
    };
  }
}